import React from 'react'
import { Link } from 'react-router-dom'

import {
  ButtonGroup,
  EmptyState,
  HeadContent,
  Loading,
  Pagination,
  Table,
  ToolbarButton,
  WebViewRemover,
  useMediaQueryContext,
} from '@fourthwall/components'
import { DownloadIcon } from '@fourthwall/icons'

import { Dashboard } from '../../../../../components/common/Dashboard'
import { PageLayout } from '../../../../../components/common/PageLayout'
import { useFilterMembers } from './hooks/useFilterMembers'
import { useMembers } from './hooks/useMembers'
import { useMembersDataExport } from './hooks/useMembersDataExport'
import { MembersFilterContainer } from './modules/MembersFilter'
import { MembersSearch } from './modules/MembersSearch'

export const Members = () => {
  const { members } = useMembers()
  const { hasFilterParams } = useFilterMembers()
  const { exportMembersData, isMembersDataLoading } = useMembersDataExport()
  const media = useMediaQueryContext()

  const getToolbarContent = () => (
    <ButtonGroup space="medium">
      <WebViewRemover>
        <Loading isLoading={isMembersDataLoading}>
          <ToolbarButton label="Export members" icon={DownloadIcon} onClick={exportMembersData} />
        </Loading>
      </WebViewRemover>
      <MembersFilterContainer />
      {media.tablet && <MembersSearch />}
    </ButtonGroup>
  )

  return (
    <PageLayout size="large">
      <Dashboard.Section
        name="Members"
        bottomMargin={media.laptop ? 'medium' : 'small'}
        toolbarContent={getToolbarContent()}
        bottomContent={!media.tablet && <MembersSearch />}
      >
        <HeadContent title="Members" />
        <Dashboard.Section.Item>
          <Dashboard.Section.ScrollableContent>
            <Table
              {...members.table}
              rowComponent={Link}
              isLoading={members.isLoading}
              emptyComponent={
                <EmptyState
                  title={hasFilterParams ? 'No members found.' : "You don't have any members yet."}
                  subtitle={
                    hasFilterParams
                      ? 'Adjust your filters or try different search term.'
                      : undefined
                  }
                  variant={media.tablet ? 'primary' : 'secondary'}
                />
              }
              minWidth={media.laptop ? undefined : 0}
            />
          </Dashboard.Section.ScrollableContent>
        </Dashboard.Section.Item>
        {members.pagination.pageCount !== 1 && (
          <Dashboard.Section.Item>
            <Pagination {...members.pagination} />
          </Dashboard.Section.Item>
        )}
      </Dashboard.Section>
    </PageLayout>
  )
}
